import styled from "styled-components";

/**
 * §2: 14px / 700 / secondary. §7: 12px down to the first control — that gap is
 * owned by the heading so the rhythm cannot be forgotten at the call site.
 */
const SectionHeading = styled.h3`
	margin: 0 0 var(--space-3);
	font-family: var(--font-family);
	font-size: var(--font-size-body);
	font-weight: var(--font-weight-bold);
	line-height: var(--line-height-base);
	color: var(--color-text-secondary);
`;

export default SectionHeading;
